import React, { useState } from "react";
import { packClasses } from "Utils";

export default function TabContainer(props) {
    const [selected, setSelected] = useState(0);
    const tabs = props.children;

    if (!tabs || !tabs.length) {
        return null;
    }
    return (
        <div>
            <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                    Select a tab
                </label>
                {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                <div className="flex justify-center">
                    <select
                        id="tabs"
                        name="tabs"
                        className="z-10 rounded-md border-gray-300 focus:border-green-500 focus:ring-green-500"
                        onChange={(e) => {
                            setSelected(parseInt(e.target.value));
                        }}
                        defaultValue={
                            tabs.find((tab, tabIdx) => tabIdx === selected)
                                .props.label
                        }
                    >
                        {tabs.map((tab, tabIdx) => (
                            <option key={tabIdx} value={tabIdx}>
                                {tab.props.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="hidden sm:block">
                <nav
                    className="relative z-0 flex divide-x divide-gray-200 rounded-lg align-middle shadow"
                    aria-label="Tabs"
                >
                    {tabs.map((tab, tabIdx) => (
                        <div
                            key={tabIdx}
                            onClick={() => setSelected(tabIdx)}
                            className={packClasses(
                                tabIdx === selected
                                    ? "text-green-600"
                                    : "text-gray-500 hover:text-gray-700",
                                tabIdx === 0 ? "rounded-l-lg" : "",
                                tabIdx === tabs.length - 1
                                    ? "rounded-r-lg"
                                    : "",
                                "group relative min-w-0 flex-1 cursor-pointer overflow-hidden bg-white py-2 px-2 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
                            )}
                            aria-current={
                                tabIdx === selected ? "page" : undefined
                            }
                        >
                            <span>{tab.props.label}</span>
                            <span
                                aria-hidden="true"
                                className={packClasses(
                                    tabIdx === selected
                                        ? "bg-green-500"
                                        : "bg-transparent",
                                    "absolute inset-x-0 bottom-0 h-0.5"
                                )}
                            />
                        </div>
                    ))}
                </nav>
            </div>
            <div className="mx-2 -mt-6 rounded border border-gray-300 bg-white p-2 shadow-sm sm:mx-0 sm:mt-0 sm:border-0 sm:bg-transparent sm:p-0 sm:shadow-none">
                {tabs.map((tab, tabIdx) => (
                    <div
                        key={tabIdx}
                        className={packClasses(
                            "my-4 text-left",
                            tabIdx === selected ? "block" : "hidden"
                        )}
                    >
                        {tab.props.children}
                    </div>
                ))}
            </div>
        </div>
    );
}

export function TabPanel(props) {
    return null;
}
